export { ClipboardModule } from "./clipboardModule";
